export const MODULE_NAV_TABS = [
  {
    id: "holidays",
    label: "Holidays",
    icon: "/assets/icons/holidayicon.svg",
    redicon: "/assets/icons/redholidayicon.svg",
    href: "/holiday",
  },
  {
    id: "stays",
    label: "Stays",
    icon: "/assets/icons/staysicon.svg",
    redicon: "/assets/icons/redstaysicon.svg",
    href: "/stays",
  },
  {
    id: "flights",
    label: "Flights",
    icon: "/assets/icons/flighticon.svg",
    redicon: "/assets/icons/redflighticon.svg",
    href: "/flights",
  },
  {
    id: "activities",
    label: "Activities",
    icon: "/assets/icons/activityicon.svg",
    redicon: "/assets/icons/redactivityicon.svg",
    href: "/activity",
  },
];

export function getActiveModuleTabId(pathname) {
  const path = (pathname || "").toLowerCase();
  if (path.startsWith("/stays")) return "stays";
  if (path.startsWith("/flights") || path.startsWith("/flight")) return "flights";
  if (path.startsWith("/activity") || path.startsWith("/activity")) return "activities";
  if (path.startsWith("/holiday") || path === "/") return "holidays";
  // return "holidays";
}
